import React from "react";

export default function OtherSection({ language, onLanguageChange, onLogout }) {
    return (
        <div className="flex flex-col gap-3 px-5 pb-5">
            <label className="flex items-center gap-2"><span className="text-base">Language</span><select className="bg-[#f6f6f8] border-none rounded-xl px-3 py-2 text-base" value={language} onChange={onLanguageChange}><option value="en">English</option><option value="es">Spanish</option><option value="fr">French</option><option value="id">Bahasa Indonesia</option></select></label>
            <button type="button" className="mt-2 px-5 py-2 bg-[#f1f1f4] text-red-500 rounded-xl hover:bg-red-50 border border-gray-200 text-base font-medium transition" onClick={onLogout}>Logout</button>
        </div>
    );
}
